/* =========================================================
   SMELU UTENSILIEN-GRID v2 — Master-Stage-Logik
   Klick auf Nummer-Chip:
     · Alle Stage-Layer auf .is-faded (außer ausgewählter)
     · Detail-Panel rechts wechselt mit Crossfade
   ========================================================= */

(function () {
  'use strict';

  function init(section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    var tools = window['SMELU_UTENSILS_' + sectionId];
    if (!tools || !tools.length) return;

    var chips     = section.querySelectorAll('[data-utensil-idx]');  // Hotspots UND Chips haben beide das Attribut
    var layers    = section.querySelectorAll('[data-utensil-layer]'); // alte Layer (gibt's nicht mehr, defensive)
    var detail    = section.querySelector('[data-utensils-detail]');
    var stepCur   = section.querySelector('[data-utensils-step-cur]');
    var detailImg = section.querySelector('[data-utensils-detail-img]');
    var detailName  = section.querySelector('[data-utensils-detail-name]');
    var detailUse   = section.querySelector('[data-utensils-detail-use]');
    var detailStory = section.querySelector('[data-utensils-detail-story]');

    if (!detail || !chips.length) return;

    var activeIdx = 1;

    function setActive(newIdx, animate) {
      if (newIdx < 1 || newIdx > tools.length) return;
      var tool = tools[newIdx - 1];
      if (!tool) return;
      activeIdx = newIdx;

      // Stage-Layer togglen
      layers.forEach(function (layer) {
        var lIdx = parseInt(layer.getAttribute('data-utensil-layer'), 10);
        layer.classList.toggle('is-active', lIdx === newIdx);
      });

      // Chips togglen
      chips.forEach(function (chip) {
        var cIdx = parseInt(chip.getAttribute('data-utensil-idx'), 10);
        var isActive = cIdx === newIdx;
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Step-Counter
      if (stepCur) {
        stepCur.textContent = ('0' + newIdx).slice(-2);
      }

      function applyData() {
        if (detailImg) {
          detailImg.innerHTML = '<img src="' + tool.img + '" alt="' + (tool.name || '') + '" loading="lazy" decoding="async">';
        }
        if (detailName)  detailName.textContent  = tool.name || '';
        if (detailUse)   detailUse.textContent   = tool.use_case || '';
        if (detailStory) detailStory.textContent = tool.story || '';
      }

      if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        detail.classList.add('is-swapping');
        setTimeout(function () {
          applyData();
          detail.classList.remove('is-swapping');
        }, 180);
      } else {
        applyData();
      }
    }

    // Initial: erstes Tool laden
    setActive(1, false);

    // Click-Handler auf Chips
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var idx = parseInt(chip.getAttribute('data-utensil-idx'), 10);
        if (idx && idx !== activeIdx) {
          setActive(idx, true);
        }
      });
    });

    // Klick auf Stage-Layer wechselt ebenfalls — Bonus: User kann
    // direkt das Tool im Bild anklicken statt die Nummer
    layers.forEach(function (layer) {
      layer.style.pointerEvents = 'auto';
      layer.style.cursor = 'pointer';
      layer.addEventListener('click', function () {
        var idx = parseInt(layer.getAttribute('data-utensil-layer'), 10);
        if (idx && idx !== activeIdx) setActive(idx, true);
      });
    });

    // Keyboard-Nav auf Chips
    section.addEventListener('keydown', function (e) {
      var target = e.target.closest('[data-utensil-idx]');
      if (!target) return;
      var newIdx = activeIdx;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          newIdx = activeIdx + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          newIdx = activeIdx - 1;
          break;
        case 'Home':
          newIdx = 1;
          break;
        case 'End':
          newIdx = tools.length;
          break;
        default:
          return;
      }
      e.preventDefault();
      if (newIdx >= 1 && newIdx <= tools.length) {
        setActive(newIdx, true);
        var nextChip = section.querySelector('[data-utensil-idx="' + newIdx + '"]');
        if (nextChip) nextChip.focus();
      }
    });
  }

  function bootAll() {
    document.querySelectorAll('.smelu-utensils').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.smelu-utensils');
    if (section) init(section);
  });
})();
